import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { formatToken } from '@ori/fetching';
import { isAuthenticatedCustomer } from '@ori/presentation-utils';
import { ACCEPT_LANGUAGE, AUTHORIZATION, CLIENT_APPLICATION, CONTENT_TYPE, CUSTOMER_CONTEXT, JSON_CONTENT, TENANT_CONTEXT } from "../../constants";

/**
 * Utility function for generating headers for HTTP requests. Returns object with headers.
 */
export var getHeaders = function getHeaders() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    applicationName = _ref.applicationName,
    currentLanguage = _ref.currentLanguage,
    customerId = _ref.customerId,
    tenant = _ref.tenant,
    token = _ref.token;
  var headers = _defineProperty({}, CONTENT_TYPE, JSON_CONTENT);
  var formattedToken = formatToken(token);
  if (formattedToken) {
    headers[AUTHORIZATION] = formattedToken;
  }
  if (applicationName) {
    headers[CLIENT_APPLICATION] = applicationName;
  }
  if (currentLanguage) {
    headers[ACCEPT_LANGUAGE] = currentLanguage;
  }
  if (isAuthenticatedCustomer(customerId)) {
    headers[CUSTOMER_CONTEXT] = customerId;
  }
  if (tenant) {
    headers[TENANT_CONTEXT] = tenant;
  }
  return headers;
};
//# sourceMappingURL=getHeaders.js.map